module.exports = __webpack_public_path__ + "static/media/no-giftcard.e361566c.png";